import { Outlet } from 'react-router-dom'

import { Features } from 'generated/featureDefinitions'
import type { AllFeatureIds } from 'generated/featureIds.generated'
import { ContractsSettingPageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import CollectionsBootstrap from 'modules/contracts_settings/lib/CollectionsBootstrap'

const devTimeoffWorkConditionsFeatureId: AllFeatureIds = 'dev_timeoff_work_conditions'
const devContractsDataAsJsonFeatureId: AllFeatureIds = 'dev_contracts_data_as_json'

const RootPage = () => {
  const { company } = useCurrentSession()

  const { data, loading, error } = useQuery(ContractsSettingPageDocument, {
    variables: {
      companyId: company.id,
      featureAvailabilityIds: [Features.compensations_management],
      featureIds: [devTimeoffWorkConditionsFeatureId, devContractsDataAsJsonFeatureId],
    },
  })

  return (
    <CollectionsBootstrap>
      <Outlet
        context={{
          loading,
          error: !!error,
          data,
        }}
      />
    </CollectionsBootstrap>
  )
}

export default RootPage
